<div>
	<div echarts [options]="options2"></div>
</div>
